import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import {
  Injectable,
  Injector
} from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from "rxjs/operators";
import { filter } from 'rxjs/operators';
import { BackendService, E2eService } from '../../../services';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) { }

  get backend(): BackendService {
    // See https://github.com/angular/angular/issues/18224
    return this.injector.get(BackendService);
  }

  get e2e(): E2eService {
    return this.injector.get(E2eService);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(catchError((error: HttpErrorResponse) => {
        if (error.headers.has('eventid')) {
          this.e2e.setEventId(error.headers.get('eventid'));
        }
        return throwError(error);
      }))
      .pipe(filter((event: HttpEvent<any>) => event instanceof HttpResponse))
      .pipe(tap((response: HttpResponse<any>) => this.receive(response)));
  }

  receive(response: HttpResponse<any>): void {
    //update biztoken with latest value from backend except for chatbot urls since it is different flow from app flow
    if (response.headers.has('biztoken')
      && response.url.indexOf("prelogin/digital/users/chatBot/koreServices/tokenAndUserInfo/retrieve") < 0) {
      this.backend.bizToken = response.headers.get('biztoken');
    }
    if (response.headers.has('eventid')) {
      this.e2e.setEventId(response.headers.get('eventid'));
    }
  }

}
